import styled from "styled-components/native"

export const Container = styled.ScrollView`
    flex: 1;
    height: 100%;
    background: #F5F6F8;
    padding: 30px;
    display: flex;
    flex-direction: column;
`